import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
  width: ${props => props.width};
  max-width: 350px;
  height: 40px;
  border: 1px solid #233467;
  background-color: #233647;
  margin-top: 50px;
  padding: 10px;
  color: #fff;
  transition: 0.3s;
  font-family: 'Bellota Text', cursive;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  :hover {
    cursor: pointer;
    background-color: #fff;
    color: #233647;
  }
`

const ButtonForm = ({
                        name = "envoyer",
                        value = "ENVOYER",
                        width = "100%",
                        onClick = null,
                        children
                    }) => {
    return (
        <Button type="submit" name={name} width={width} onClick={onClick}>
            {value}{children}
        </Button>
    )
}

export default ButtonForm
